/* eslint-disable @typescript-eslint/camelcase */
import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const CUSTOMOPTIN = [
    // 登録日
    {
      display_id: 'registration_date',
      props: {
        format: 'yyyy/MM/dd'
      }
    },
    // 郵便番号
    {
      display_id: 'postal_code',
      component: 'Zipcode',
      props: {
        label: '郵便番号',
        name: '郵便番号'
      },
      row: 4,
      col: 0,
      sizeX: 2,
      sizeY: 1
    },
    // 生年月日
    {
      display_id: 'birthday',
      props: {
        format: 'yyyy/MM/dd'
      }
    },
    // 顧客名
    {
      display_id: 'customer_name',
      props: {
        placeholder: '36文字以内',
        maxlength: 36
      }
    },
    // 顧客名カナ
    {
      display_id: 'customer_kana',
      props: {
        placeholder: '32文字以内',
        maxlength: 32
      }
    },
    // 町村丁番地
    {
      display_id: 'machimura_street_address',
      props: {
        placeholder: '20文字以内',
        maxlength: 20
      }
    },
    // ビル・建物名
    {
      display_id: 'building_name',
      props: {
        placeholder: '26文字以内',
        maxlength: 26
      }
    },
    // 法人番号
    {
      display_id: 'corporate_number',
      props: {
        placeholder: '数値13文字',
        maxlength: 13
      },
      show: false
    }
  ];
  export const CustomerEditOptions = [
    // 登録日
    {
      display_id: 'registration_date',
      props: {
        format: 'yyyy/MM/dd'
      }
    },
    // 郵便番号
    {
      display_id: 'postal_code',
      component: 'Zipcode',
      props: {
        label: '郵便番号',
        name: '郵便番号'
      },
      row: 4,
      col: 0,
      sizeX: 2,
      sizeY: 1
    },
    // 顧客名
    {
      display_id: 'customer_name',
      props: {
        tooltipProps: {
          disapled: false,
          bottom: true,
        }
      }
    },
    // 生年月日
    {
      display_id: 'birthday',
      props: {
        format: 'yyyy/MM/dd'
      }
    },
    // 顧客名
    {
      display_id: 'customer_name',
      props: {
        placeholder: '36文字以内',
        maxlength: 36
      }
    },
    // 顧客名カナ
    {
      display_id: 'customer_kana',
      props: {
        placeholder: '32文字以内',
        maxlength: 32
      }
    },
    // 町村丁番地
    {
      display_id: 'machimura_street_address',
      props: {
        placeholder: '20文字以内',
        maxlength: 20
      }
    },
    // ビル・建物名
    {
      display_id: 'building_name',
      props: {
        placeholder: '26文字以内',
        maxlength: 26
      }
    },
    // 法人番号
    {
      display_id: 'corporate_number',
      props: {
        placeholder: '数値13文字',
        maxlength: 13
      },
      show: false      
    }
  ];
  export const CustomerDepartmentOptions = [
    // 部署名
    {
      display_id: 'department_name',
      props: {
        placeholder: '36文字以内',
        maxlength: 36
      }
    },
    // 部署名カナ
    {
      display_id: 'department_name_kana',
      props: {
        placeholder: '32文字以内',
        maxlength: 32
      }
    },
    // 郵便番号
    {
      display_id: 'postal_code',
      component: 'Zipcode',
      props: {
        label: '郵便番号',
        name: '郵便番号',
        isBtnVisible: false
      },
      sizeX: 2,
      sizeY: 1
    },
    // 部署名
    {
      display_id: 'department_name',
      props: {
        placeholder: '36文字以内',
        maxlength: 36
      }
    },
    // 町村丁番地
    {
      display_id: 'machimura_street_address',
      props: {
        placeholder: '20文字以内',
        maxlength: 20
      }
    },
    // ビル・建物名
    {
      display_id: 'building_name',
      props: {
        placeholder: '26文字以内',
        maxlength: 26
      }
    }
  ];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace headerForm {
  export const customerDepartmentRegister: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      search: false,
      show_list: false,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 1,
      full_text: false,
      unique: false,
      min_value: '',
      max_value: '',
      // ****** //
      field_id: '見込顧客番号',
      name: '見込顧客番号',
      display_id: '見込顧客番号',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: '見込顧客番号',
        labelText: '見込顧客番号',
        name: '見込顧客番号',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 0,
      row: 0,
      show: true
    },
    {
      search: true,
      show_list: true,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 2,
      full_text: false,
      unique: true,
      min_value: '',
      max_value: '',
      field_id: '顧客名',
      name: '顧客名',
      display_id: '顧客名',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: '顧客名',
        labelText: '顧客名',
        name: '顧客名',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 1,
      row: 0,
      show: true
    },
    {
      search: true,
      show_list: true,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 2,
      full_text: false,
      unique: true,
      min_value: '',
      max_value: '',
      field_id: '顧客連絡先',
      name: '顧客連絡先',
      display_id: '顧客連絡先',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: '顧客連絡先',
        labelText: '顧客連絡先',
        name: '顧客連絡先',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 3,
      row: 0,
      show: true
    }
  ];
}

export const customerDepartmentRegisterHeader = headerForm.customerDepartmentRegister;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace masterForm {
  export const MASTERCONTROLCOLUMS: { [k: string]: Array<{ [k: string]: string }> } = {
    m_customer: [
      { value: 'customer_id', text: '見込顧客番号', width: '30%' },
      { value: 'customer_name', text: '顧客名', width: '50%' }
    ],
    m_customer_department: [
      { value: 'department_id', text: '部署番号', width: '20%' },
      { value: 'department_name', text: '部署名', width: '20%' }
    ],
    m_leasing_company: [
      { value: 'id', text: 'ID', width: '10%' },
      { value: 'leasing_company', text: 'リース会社名', width: '40%' },
      { value: '料率', text: '料率', width: '10%' },
      { value: '契約月数', text: '契約月数', width: '20%' }
    ],
    m_rate: [{ value: 'id', text: 'ID', width: '10%' }],
    m_employee: [
      { value: 'display_employee_id', text: '社員ID', width: '20%' },
      { value: 'name', text: '社員名', width: '20%' }
    ],
    m_service_type: [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'service_type', text: 'サービス種別', width: '50%' }
    ],
    m_commodity: [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'commodity', text: '商材', width: '30%' }
    ]
  };
}

export const customerOptionalForm = optionalForm.CUSTOMOPTIN;
export const customerEditOptionalForm = optionalForm.CustomerEditOptions;
export const CustomerDepartmentOptionalForm = optionalForm.CustomerDepartmentOptions;
export const masterControlColums = masterForm.MASTERCONTROLCOLUMS;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace formDefine {
  // APIから取得したDatatypeと使用するべきモジュールコンポーネントをマッピング用
  export const MAPPING: { [k: string]: { component: string; props: string[] } } = {
    text: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name']
    },
    number: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name', 'inputType']
    },
    select: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
    textarea: {
      component: 'TextArea',
      props: ['labelName', 'labelText', 'name']
    },
    datetime: {
      component: 'DatePickerArea',
      props: ['labelName', 'labelText', 'name']
    },
    radio: {
      component: 'RadioArea',
      props: ['label', 'selectData', 'name']
    },
    dslookup: {
      component: 'MasterSelectControl',
      props: ['leftSideInputName', 'dialogTitle', 'label', 'isRightSideInputReadOnly']
    },
    status: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    }
  };
  // 使用するモジュールコンポーネントの各propsにセットするAPIの返り値をマッピング
  export const settingPropsValue: { [k: string]: string } = {
    labelName: 'display_id',
    labelText: 'name',
    label: 'name',
    name: 'display_id',
    selectData: 'options',
    inputType: 'dataType'
  };
}

export const formMapDefineData = formDefine.MAPPING;
export const formMapPropsDefineData = formDefine.settingPropsValue;

// 帳票関連
export const formFormatReplaceStr = 'is_output_';

// ファイル関連
export const fileActionMasterDefuneName = {
  delete: {
    success: 'FILE_DELETE_SUCCESS_MESSAGE',
    fail: 'FILE_DELETE_FAIL_MESSAGE'
  },
  upload: {
    success: 'FILE_UPLOAD_SUCCESS_MESSAGE',
    fail: 'FILE_UPLOAD_FAIL_MESSAGE'
  }
};
export const fileActionDefautMessage = {
  delete: {
    success: 'ファイルを削除しました。',
    fail: 'ファイルの削除に失敗しました。'
  },
  upload: {
    success: 'ファイルを登録しました。',
    fail: 'ファイルの登録に失敗しました。'
  }
};
export const buttonLabel: { [k: string]: string } = {
  delete: '削除',
  download: 'ダウンロード'
};
export const tableColumn: { [k: string]: any } = {
  columns: [
    { text: 'ファイル名', value: 'name' },
    { text: '', value: 'file_id', sortable: false, width: 70 }
  ],
  buttonItems: [
    {
      name: 'file_id',
      text: '',
      icon: 'mdi-delete-outline',
      alwaysDisplayed: true,
      class: 'btn-icon--noframe',
      disabled: true
    }
  ]
};
/* eslint-enable @typescript-eslint/camelcase */
